<i18n lang="yaml">
en:
  common: Common
  language: Language
  ssh_keys: SSH Keys
ru:
  common: Общее
  language: Язык
  ssh_keys: Ключи SSH
</i18n>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="row">
    <div class="col">
      <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <router-link :to="{ name: 'account:profile' }" class="nav-link" type="button">{{
            t('common')
          }}</router-link>
        </li>

        <li class="nav-item" role="presentation">
          <router-link :to="{ name: 'account:keys:list' }" class="nav-link" type="button">{{
            t('ssh_keys')
          }}</router-link>
        </li>
      </ul>
    </div>

    <div class="col-10">
      <div class="tab-content">
        <router-view />
      </div>
    </div>
  </div>
</template>
